import { render, staticRenderFns } from "./ProjectEditDocumentsTab.vue?vue&type=template&id=c3953248"
import script from "./ProjectEditDocumentsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditDocumentsTab.vue?vue&type=script&lang=ts"
import style0 from "./ProjectEditDocumentsTab.vue?vue&type=style&index=0&id=c3953248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports